import FlexPane from 'presentation/components/flex-pane/index.js';
import Text from 'presentation/components/text/index.js';
import ParticipantItem from 'presentation/components/participant-item/index.js';
import { getSeparatorTranslationKey } from 'presentation/formatters/participant-separator/index.js';
import {
    useCompetitorsIconsQuery,
    useEnrichedCompetitorsWithSportId,
} from 'presentation/components/competitor-icon/hooks/index.js';

export default function Participants(props) {
    const {
        event,
        mojitoTools: { config, stringResolver },
        drawLabel,
        forceDisplayEventName,
    } = props;

    const hasMoreThanOneParticipant = event.participants?.length > 1;
    const hasThreeParticipants = event?.participants?.length === 3;
    const showEventName = forceDisplayEventName || !hasMoreThanOneParticipant;
    let showTeamLogo = config.participantItem.showTeamLogo;

    const competitors = useEnrichedCompetitorsWithSportId({
        competitors: event.participants,
        sportId: event.sportId,
        homeAway: event.homeAway,
    });

    const { competitorsWithIcons } = useCompetitorsIconsQuery({
        competitors: showTeamLogo ? competitors : undefined,
        config: config.competitorIconOptions,
    });

    const participants = showTeamLogo ? competitorsWithIcons : competitors;

    const hasResolvedTeamLogos = participants.some(participant => Boolean(participant.iconSrc));

    showTeamLogo = showTeamLogo && hasResolvedTeamLogos;

    return (
        <FlexPane config={config.container} class="ta-Participants">
            {showEventName ? (
                <EventNameLabel event={event} config={config} />
            ) : (
                <>
                    <ParticipantItem
                        config={config.participantItem}
                        sportId={event.sportId}
                        participant={participants[0]}
                        showTeamLogo={showTeamLogo}
                    />
                    {config.showSeparator && (
                        <SeparatorLabel
                            hasTeamLogo={showTeamLogo}
                            config={config}
                            text={stringResolver.resolveString(
                                getSeparatorTranslationKey(event.homeAway)
                            )}
                        />
                    )}
                    <ParticipantItem
                        config={config.participantItem}
                        sportId={event.sportId}
                        participant={participants[1]}
                        showTeamLogo={showTeamLogo}
                    />
                    {hasThreeParticipants && config.showSeparator && (
                        <SeparatorLabel
                            hasTeamLogo={showTeamLogo}
                            config={config}
                            text={stringResolver.resolveString(
                                getSeparatorTranslationKey(event.homeAway)
                            )}
                        />
                    )}
                    {hasThreeParticipants && (
                        <ParticipantItem
                            config={config.participantItem}
                            sportId={event.sportId}
                            participant={participants[2]}
                            showTeamLogo={showTeamLogo}
                        />
                    )}
                    <DrawLabel config={config} text={drawLabel} />
                </>
            )}
        </FlexPane>
    );
}

const EventNameLabel = ({ event, config }) => {
    return (
        <Text config={config.outrightText} class="ta-outRightType">
            {event.name}
        </Text>
    );
};

const DrawLabel = ({ config, text }) => {
    if (!text) {
        return null;
    }

    return (
        <FlexPane config={config.drawLabelTextWrapper}>
            <Text class="ta-drawLabel" config={config.drawLabelText}>
                {text}
            </Text>
        </FlexPane>
    );
};

const SeparatorLabel = ({ config, text, hasTeamLogo }) => {
    if (!text) {
        return null;
    }

    const separatorWrapperConfig = hasTeamLogo
        ? config.separatorWrapperWithTeamLogo
        : config.separatorWrapper;

    return (
        <FlexPane config={separatorWrapperConfig}>
            <Text class="ta-separatorLabel" config={config.separatorText}>
                {text}
            </Text>
        </FlexPane>
    );
};
